export const CHAT_EMOJIS = [
	'😀',
	'😃',
	'😄',
	'😁',
	'😊',
	'🙂',
	'😉',
	'😍',
	'🥳',
	'😂',
	'😅',
	'🤔',
	'😕',
	'😢',
	'🙏',
	'👍',
	'👎',
	'👏',
	'🙌',
	'👋',
	'👌',
	'💪',
	'🤝',
	'❤️',
	'💙',
	'💚',
	'✨',
	'⭐',
	'🎉',
	'✅',
	'❌',
	'⚠️',
	'💡',
	'📦',
	'🚚',
	'📍',
	'📞',
	'✉️',
	'🔗',
	'⏰',
] as const;

export function insertEmoji(
	value: string,
	emoji: string,
	start: number,
	end: number,
): { cursor: number; value: string } {
	const safeStart = Math.max(0, Math.min(value.length, start));
	const safeEnd = Math.max(safeStart, Math.min(value.length, end));
	return {
		cursor: safeStart + emoji.length,
		value: `${value.slice(0, safeStart)}${emoji}${value.slice(safeEnd)}`,
	};
}
